import React from 'react'

import PreviousArrow from '../previous-arrow/previous-arrow.component'
import Reassurance from '../reassurance/reassurance.component'
import SubscriptionOverview from '../subscription-overview/subscription-overview.component'
import NextButton from '../next-button/next-button.component'

import './sticky-button.styles.scss'

const StickyButton = () => {
  return (
    <div className='sticky-button'>
      <div className='sticky-button-element' data-element='arrow'>
        <PreviousArrow color={'black'} />
      </div>
      <div className='sticky-button-element' data-element='reassurance'>
        <Reassurance location='sticky-button' />
      </div>
      <div className='sticky-button-element' data-element='overview'>
        <SubscriptionOverview />
      </div>
      <div className='sticky-button-element' data-element='button'>
        <NextButton />
      </div>
    </div>
  )
}

export default StickyButton
